// Écosystème PROGÈRE — liste centrale des modules (sélecteur d'applications).
// Le STATUT réel (inclus / verrouillé / bientôt) provient du serveur via GET /api/ecosystem/modules.
// Ce fichier ne porte que la présentation (nom, icône, couleur, description, domaine).
// color: "red" | "gold"
export const PROGERE_MODULES = [
  { code: "core", name: "PROGÈRE CORE", short: "CORE", icon: "LayoutGrid", color: "gold",
    desc: "Centre de votre écosystème", domain: "https://progere.ca" },
  { code: "punch", name: "PUNCH", short: "PUNCH", icon: "Fingerprint", color: "red",
    desc: "Heures, équipes et présences", domain: "https://punch.progere.ca" },
  { code: "crm", name: "CRM", short: "CRM", icon: "Users", color: "gold",
    desc: "Clients, ventes et opportunités", domain: "https://crm.progere.ca" },
  { code: "erp", name: "ERP", short: "ERP", icon: "Building2", color: "red",
    desc: "Projets et opérations", domain: "https://erp.progere.ca" },
  { code: "compta", name: "COMPTA", short: "COMPTA", icon: "Calculator", color: "gold",
    desc: "Comptabilité et finances", domain: "https://compta.progere.ca" },
  { code: "paie", name: "PAIE", short: "PAIE", icon: "WalletCards", color: "red",
    desc: "Paie et ressources humaines", domain: "https://paie.progere.ca" },
  { code: "devis", name: "DEVIS AI", short: "DEVIS AI", icon: "Sparkles", color: "gold",
    desc: "Soumissions intelligentes", domain: "https://devis.progere.ca" },
  { code: "takeoff", name: "TAKE OFF", short: "TAKE OFF", icon: "Ruler", color: "red",
    desc: "Métrés et quantités", domain: "https://takeoff.progere.ca" },
  { code: "support", name: "SUPPORT", short: "SUPPORT", icon: "LifeBuoy", color: "gold",
    desc: "Aide et assistance", domain: "https://support.progere.ca" },
];

export const MODULE_BY_CODE = Object.fromEntries(PROGERE_MODULES.map((m) => [m.code, m]));
